import { QUICK_ALGOLIA_SEARCH_QUERY } from '../Actions/AlgoliaSearch.action';

const DEFAULT_STATE = {
  algoliaQuery: new URL(window.location.href).searchParams.get('q') || '',
};

export const algoliaSearch = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case QUICK_ALGOLIA_SEARCH_QUERY:
      return {
        ...state,
        ...action.payload,
      }
    default:
      return state;
  }
}